import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const Buyer = () => {
    const [buyer, setBuyer] = React.useState([
    ])
     const [search, setSearch] = useState("");
    // const [editState, setEditState] = React.useState(0);
    //This toast will appear when buyer gets deleted
    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
    //Buyer deletion fuction
    const deleteBuyer = (id) => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + `/Buyer/deleteBuyer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`

                },
                body: JSON.stringify({ id })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    // loadData()
                    notify(data.message);
                    loadBuyerList()
                }
                ).catch(err => notify(err))
        } catch (error) {
            console.log(error)
        }
    }
    const loadBuyerList = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_SERVER_URL + '/buyer/getAllBuyer', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
            const data = await response.json()
            console.log(data)

            setBuyer(data.buyer)
        }
        catch (err) {
            console.log(err)
        }
    }

    const resetOTPcount = (id) => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + `/Buyer/changeotpCount`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ id })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    // loadData()
                    notify(data.message);
                    loadBuyerList()
                }
                ).catch(err => notify(err))
        } catch (error) {
            console.log(error)
        }
    }
   
    useEffect(() => {
      if (search !== "") {
        let filteredBuyers = buyer.filter((item) =>
          item.username.toLowerCase().includes(search.toLowerCase())
        );
        setBuyer(filteredBuyers);
      } else {
        setBuyer(buyer);
      }
        loadBuyerList();
    }, [search,buyer]);


    React.useEffect(() => {
        loadBuyerList()
    }, [])

    return (
      <div>
        <Navbar />
        <div
          className="text-3xl w-full font-bold bg-gradient-to-l from-green-200 to-green-500"
          style={{ textAlign: "center" }}
        >
          <p className="pt-2">Buyers</p>
        </div>
        <div className=" flex flex-row items-center">
          <div className="m-2 mt-8 bg-slate-500 px-3 py-1 text-green-400 rounded-2xl font-bold">
            Search
          </div>
          <input
            type="text"
            placeholder="      Buyer Username"
            className="mt-5 ml-3 dark:bg-black dark:text-white bg-gray-200 border border-gray-400 rounded-2xl py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>

        <section className="min-h-screen">
          <div className="overflow-x-auto relative shadow-md sm:rounded-lg text-center">
            <h3>Total Buyer : {buyer.length}</h3>
            <table
              className="w-full text-sm text-gray-500 dark:text-gray-400 container mx-auto mt-10 text-center"
              border={2}
            >
              <thead className="text-xs font-bold text-gray-700 uppercase bg-gray-200 dark:text-gray-400">
                <tr>
                  <th scope="col" className="py-3 px-6">
                    Name
                  </th>
                  <th scope="col" className="py-3 px-6">
                    User Name
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Email
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Total Purchase
                  </th>
                  <th scope="col" className="py-3 px-6">
                    OPT COUNT
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {buyer.length > 0 ? (
                  buyer.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 m-auto"
                      >
                        <td className="py-4 px-6">{item.name}</td>
                        <td className="py-4 px-6">{item.username}</td>
                        <td className="py-4 px-6">{item.email}</td>
                        <td className="py-4 px-6">{item.price}</td>
                        <td className="py-4 px-6">
                          <button
                            onClick={() => resetOTPcount(item._id)}
                            className={classNames(
                              " uppercase leading-wide font-bold text-xs rounded-full shadow-sm mt-2 py-2 px-5 ",
                              item.otpCount === 5
                                ? "bg-green-800 text-green-100"
                                : null,
                              item.otpCount < 5 && item.otpCount > 0
                                ? "bg-yellow-800 text-yellow-100"
                                : null,
                              item.otpCount === 0
                                ? "bg-red-400 text-red-100"
                                : null
                            )}
                          >
                            {item.otpCount}
                          </button>
                        </td>
                        <td className="py-4 px-6  ">
                          <button
                            onClick={() => {
                              deleteBuyer(item._id);
                            }}
                            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
        <Footer />
      </div>
    );
}

export default Buyer